import DefaultFlag from './locales/Default.svg';
import AD from './locales/AD.svg';
import AE from './locales/AE.svg';
import AF from './locales/AF.svg';
import AG from './locales/AG.svg';
import AL from './locales/AL.svg';
import AM from './locales/AM.svg';
import AO from './locales/AO.svg';
import AR from './locales/AR.svg';
import AT from './locales/AT.svg';
import AU from './locales/AU.svg';
import AW from './locales/AW.svg';
import AZ from './locales/AZ.svg';

import BA from './locales/BA.svg';
import BB from './locales/BB.svg';
import BD from './locales/BD.svg';
import BE from './locales/BE.svg';
import BF from './locales/BF.svg';
import BG from './locales/BG.svg';
import BH from './locales/BH.svg';
import BI from './locales/BI.svg';
import BJ from './locales/BJ.svg';
import BN from './locales/BN.svg';
import BO from './locales/BO.svg';
import BR from './locales/BR.svg';
import BS from './locales/BS.svg';
import BT from './locales/BT.svg';
import BV from './locales/BV.svg';
import BW from './locales/BW.svg';
import BY from './locales/BY.svg';
import BZ from './locales/BZ.svg';

import CA from './locales/CA.svg';
import CD from './locales/CD.svg';
import CF from './locales/CF.svg';
import CG from './locales/CG.svg';
import CH from './locales/CH.svg';
import CI from './locales/CI.svg';
import CL from './locales/CL.svg';
import CM from './locales/CM.svg';
import CN from './locales/CN.svg';
import CO from './locales/CO.svg';
import CR from './locales/CR.svg';
import CU from './locales/CU.svg';
import CV from './locales/CV.svg';
import CW from './locales/CW.svg';
import CY from './locales/CY.svg';
import CZ from './locales/CZ.svg';

import DE from './locales/DE.svg';
import DJ from './locales/DJ.svg';
import DK from './locales/DK.svg';
import DM from './locales/DM.svg';
import DO from './locales/DO.svg';
import DZ from './locales/DZ.svg';

import EC from './locales/EC.svg';
import EE from './locales/EE.svg';
import EG from './locales/EG.svg';
import ER from './locales/ER.svg';
import ES from './locales/ES.svg';
import ET from './locales/ET.svg';

import FI from './locales/FI.svg';
import FJ from './locales/FJ.svg';
import FM from './locales/FM.svg';
import FR from './locales/FR.svg';

import GA from './locales/GA.svg';
import GB from './locales/GB.svg';
import GD from './locales/GD.svg';
import GE from './locales/GE.svg';
import GH from './locales/GH.svg';
import GM from './locales/GM.svg';
import GN from './locales/GN.svg';
import GQ from './locales/GQ.svg';
import GR from './locales/GR.svg';
import GT from './locales/GT.svg';
import GW from './locales/GW.svg';
import GY from './locales/GY.svg';

import HK from './locales/HK.svg';
import HN from './locales/HN.svg';
import HR from './locales/HR.svg';
import HT from './locales/HT.svg';
import HU from './locales/HU.svg';

import ID from './locales/ID.svg';
import IE from './locales/IE.svg';
import IL from './locales/IL.svg';
import IN from './locales/IN.svg';
import IQ from './locales/IQ.svg';
import IR from './locales/IR.svg';
import IS from './locales/IS.svg';
import IT from './locales/IT.svg';

import JM from './locales/JM.svg';
import JO from './locales/JO.svg';
import JP from './locales/JP.svg';

import KE from './locales/KE.svg';
import KG from './locales/KG.svg';
import KH from './locales/KH.svg';
import KI from './locales/KI.svg';
import KM from './locales/KM.svg';
import KP from './locales/KP.svg';
import KR from './locales/KR.svg';
import KW from './locales/KW.svg';
import KZ from './locales/KZ.svg';

import LA from './locales/LA.svg';
import LB from './locales/LB.svg';
import LC from './locales/LC.svg';
import LI from './locales/LI.svg';
import LK from './locales/LK.svg';
import LR from './locales/LR.svg';
import LS from './locales/LS.svg';
import LT from './locales/LT.svg';
import LU from './locales/LU.svg';
import LV from './locales/LV.svg';
import LY from './locales/LY.svg';

import MA from './locales/MA.svg';
import MC from './locales/MC.svg';
import MD from './locales/MD.svg';
import ME from './locales/ME.svg';
import MG from './locales/MG.svg';
import MH from './locales/MH.svg';
import MK from './locales/MK.svg';
import ML from './locales/ML.svg';
import MM from './locales/MM.svg';
import MN from './locales/MN.svg';
import MR from './locales/MR.svg';
import MT from './locales/MT.svg';
import MU from './locales/MU.svg';
import MV from './locales/MV.svg';
import MW from './locales/MW.svg';
import MX from './locales/MX.svg';
import MY from './locales/MY.svg';
import MZ from './locales/MZ.svg';

import NA from './locales/NA.svg';
import NE from './locales/NE.svg';
import NG from './locales/NG.svg';
import NI from './locales/NI.svg';
import NL from './locales/NL.svg';
import NO from './locales/NO.svg';
import NP from './locales/NP.svg';
import NR from './locales/NR.svg';
import NZ from './locales/NZ.svg';

import OM from './locales/OM.svg';

import PA from './locales/PA.svg';
import PE from './locales/PE.svg';
import PG from './locales/PG.svg';
import PH from './locales/PH.svg';
import PK from './locales/PK.svg';
import PL from './locales/PL.svg';
import PS from './locales/PS.svg';
import PT from './locales/PT.svg';
import PW from './locales/PW.svg';
import PY from './locales/PY.svg';

import QA from './locales/QA.svg';

import RO from './locales/RO.svg';
import RS from './locales/RS.svg';
import RU from './locales/RU.svg';
import RW from './locales/RW.svg';

import SA from './locales/SA.svg';
import SB from './locales/SB.svg';
import SC from './locales/SC.svg';
import SD from './locales/SD.svg';
import SE from './locales/SE.svg';
import SG from './locales/SG.svg';
import SI from './locales/SI.svg';
import SK from './locales/SK.svg';
import SL from './locales/SL.svg';
import SM from './locales/SM.svg';
import SN from './locales/SN.svg';
import SO from './locales/SO.svg';
import SR from './locales/SR.svg';
import SS from './locales/SS.svg';
import ST from './locales/ST.svg';
import SV from './locales/SV.svg';
import SX from './locales/SX.svg';
import SY from './locales/SY.svg';
import SZ from './locales/SZ.svg';

import TD from './locales/TD.svg';
import TG from './locales/TG.svg';
import TH from './locales/TH.svg';
import TJ from './locales/TJ.svg';
import TL from './locales/TL.svg';
import TM from './locales/TM.svg';
import TN from './locales/TN.svg';
import TO from './locales/TO.svg';
import TR from './locales/TR.svg';
import TT from './locales/TT.svg';
import TV from './locales/TV.svg';
import TZ from './locales/TZ.svg';

import UA from './locales/UA.svg';
import UG from './locales/UG.svg';
import US from './locales/US.svg';
import UY from './locales/UY.svg';
import UZ from './locales/UZ.svg';

import VA from './locales/VA.svg';
import VC from './locales/VC.svg';
import VE from './locales/VE.svg';
import VI from './locales/VI.svg';
import VN from './locales/VN.svg';
import VU from './locales/VU.svg';

import WS from './locales/WS.svg';

import YE from './locales/YE.svg';

import ZA from './locales/ZA.svg';
import ZM from './locales/ZM.svg';
import ZW from './locales/ZW.svg';

export type FlagIconCode =
  | 'default'
  | 'AD'
  | 'AE'
  | 'AF'
  | 'AG'
  | 'AI'
  | 'AL'
  | 'AM'
  | 'AO'
  | 'AR'
  | 'AS'
  | 'AT'
  | 'AU'
  | 'AW'
  | 'AX'
  | 'AZ'
  | 'BA'
  | 'BB'
  | 'BD'
  | 'BE'
  | 'BF'
  | 'BG'
  | 'BH'
  | 'BI'
  | 'BJ'
  | 'BL'
  | 'BM'
  | 'BN'
  | 'BO'
  | 'BR'
  | 'BS'
  | 'BT'
  | 'BV'
  | 'BW'
  | 'BY'
  | 'BZ'
  | 'CA'
  | 'CC'
  | 'CD'
  | 'CF'
  | 'CG'
  | 'CH'
  | 'CI'
  | 'CK'
  | 'CL'
  | 'CM'
  | 'CN'
  | 'CO'
  | 'CR'
  | 'CU'
  | 'CV'
  | 'CW'
  | 'CX'
  | 'CY'
  | 'CZ'
  | 'DE'
  | 'DJ'
  | 'DK'
  | 'DM'
  | 'DO'
  | 'DZ'
  | 'EC'
  | 'EE'
  | 'EG'
  | 'ER'
  | 'ES'
  | 'ET'
  | 'EU'
  | 'FI'
  | 'FJ'
  | 'FK'
  | 'FM'
  | 'FO'
  | 'FR'
  | 'GA'
  | 'GB'
  | 'GD'
  | 'GE'
  | 'GF'
  | 'GG'
  | 'GH'
  | 'GI'
  | 'GL'
  | 'GM'
  | 'GN'
  | 'GP'
  | 'GQ'
  | 'GR'
  | 'GS'
  | 'GT'
  | 'GU'
  | 'GW'
  | 'GY'
  | 'HK'
  | 'HM'
  | 'HN'
  | 'HR'
  | 'HT'
  | 'HU'
  | 'ID'
  | 'IE'
  | 'IL'
  | 'IM'
  | 'IN'
  | 'IO'
  | 'IQ'
  | 'IR'
  | 'IS'
  | 'IT'
  | 'JE'
  | 'JM'
  | 'JO'
  | 'JP'
  | 'KE'
  | 'KG'
  | 'KH'
  | 'KI'
  | 'KM'
  | 'KN'
  | 'KP'
  | 'KR'
  | 'KW'
  | 'KY'
  | 'KZ'
  | 'LA'
  | 'LB'
  | 'LC'
  | 'LI'
  | 'LK'
  | 'LR'
  | 'LS'
  | 'LT'
  | 'LU'
  | 'LV'
  | 'LY'
  | 'MA'
  | 'MC'
  | 'MD'
  | 'ME'
  | 'MF'
  | 'MG'
  | 'MH'
  | 'MK'
  | 'ML'
  | 'MM'
  | 'MN'
  | 'MO'
  | 'MP'
  | 'MQ'
  | 'MR'
  | 'MS'
  | 'MT'
  | 'MU'
  | 'MV'
  | 'MW'
  | 'MX'
  | 'MY'
  | 'MZ'
  | 'NA'
  | 'NC'
  | 'NE'
  | 'NF'
  | 'NG'
  | 'NI'
  | 'NL'
  | 'NO'
  | 'NP'
  | 'NR'
  | 'NU'
  | 'NZ'
  | 'OM'
  | 'PA'
  | 'PE'
  | 'PF'
  | 'PG'
  | 'PH'
  | 'PK'
  | 'PL'
  | 'PM'
  | 'PN'
  | 'PR'
  | 'PS'
  | 'PT'
  | 'PW'
  | 'PY'
  | 'QA'
  | 'RE'
  | 'RO'
  | 'RS'
  | 'RU'
  | 'RW'
  | 'SA'
  | 'SB'
  | 'SC'
  | 'SD'
  | 'SE'
  | 'SG'
  | 'SH'
  | 'SI'
  | 'SJ'
  | 'SK'
  | 'SL'
  | 'SM'
  | 'SN'
  | 'SO'
  | 'SR'
  | 'SS'
  | 'ST'
  | 'SV'
  | 'SX'
  | 'SY'
  | 'SZ'
  | 'TC'
  | 'TD'
  | 'TF'
  | 'TG'
  | 'TH'
  | 'TJ'
  | 'TK'
  | 'TL'
  | 'TM'
  | 'TN'
  | 'TO'
  | 'TR'
  | 'TT'
  | 'TV'
  | 'TW'
  | 'TZ'
  | 'UA'
  | 'UG'
  | 'UM'
  | 'US'
  | 'UY'
  | 'UZ'
  | 'VA'
  | 'VC'
  | 'VE'
  | 'VG'
  | 'VI'
  | 'VN'
  | 'VU'
  | 'WF'
  | 'WS'
  | 'XK'
  | 'YE'
  | 'YT'
  | 'ZA'
  | 'ZM'
  | 'ZW';

interface Flags {
  [key: string]: string;
}

export const flags: Flags = {
  default: DefaultFlag,
  AD,
  AE,
  AF,
  AG,
  AM,
  AO,
  AU,
  AW,
  AL,
  AR,
  AT,
  AZ,
  BA,
  BB,
  BD,
  BE,
  BF,
  BG,
  BH,
  BI,
  BJ,
  BN,
  BO,
  BR,
  BS,
  BT,
  BV,
  BW,
  BY,
  BZ,
  CA,
  CD,
  CF,
  CG,
  CH,
  CI,
  CL,
  CM,
  CN,
  CO,
  CR,
  CU,
  CV,
  CW,
  CY,
  CZ,
  DE,
  DJ,
  DK,
  DM,
  DO,
  DZ,
  EC,
  EE,
  EG,
  ER,
  ES,
  ET,
  FI,
  FJ,
  FM,
  FR,
  GA,
  GB,
  GD,
  GE,
  GH,
  GM,
  GN,
  GQ,
  GR,
  GT,
  GW,
  GY,
  HK,
  HN,
  HR,
  HT,
  HU,
  ID,
  IE,
  IL,
  IN,
  IQ,
  IR,
  IS,
  IT,
  JM,
  JO,
  JP,
  KE,
  KG,
  KH,
  KI,
  KM,
  KP,
  KR,
  KW,
  KZ,
  LA,
  LB,
  LC,
  LI,
  LK,
  LR,
  LS,
  LT,
  LU,
  LV,
  LY,
  MA,
  MC,
  MD,
  ME,
  MG,
  MH,
  MK,
  ML,
  MM,
  MN,
  MR,
  MT,
  MU,
  MV,
  MW,
  MX,
  MY,
  MZ,
  NA,
  NE,
  NG,
  NI,
  NL,
  NO,
  NP,
  NR,
  NZ,
  OM,
  PA,
  PE,
  PG,
  PH,
  PK,
  PL,
  PS,
  PT,
  PW,
  PY,
  QA,
  RO,
  RS,
  RU,
  RW,
  SA,
  SB,
  SC,
  SD,
  SE,
  SG,
  SI,
  SK,
  SL,
  SM,
  SN,
  SO,
  SR,
  SS,
  ST,
  SV,
  SX,
  SY,
  SZ,
  TD,
  TG,
  TH,
  TJ,
  TL,
  TM,
  TN,
  TO,
  TR,
  TT,
  TV,
  TZ,
  UA,
  UG,
  US,
  UY,
  UZ,
  VA,
  VC,
  VE,
  VI,
  VN,
  VU,
  WS,
  YE,
  ZA,
  ZM,
  ZW,
};
